module.exports = __webpack_public_path__ + "static/media/invoices-mobile.4c5cd550.svg";